export interface TaxPreviewVars {
  payer_full_name: string
  payer_inn: string
  services_patient_different: boolean
  services_patient_full_name: string
  services_patient_inn: string
  finance_source_mis_id: string
  finance_source_label: string
  certificate_number: string
  period_end: string
  code1_rub: number
  code2_rub: number
}

function splitName(fullName: string): [string, string, string] {
  const parts = fullName.trim().split(/\s+/)
  return [parts[0] ?? '', parts[1] ?? '', parts[2] ?? '']
}

function formatAmount(amount: number): string {
  if (!amount) return '—'
  const rub = Math.floor(amount)
  const kop = Math.round((amount - rub) * 100)
  return `${rub.toLocaleString('ru-RU')} ₽ ${String(kop).padStart(2, '0')} коп.`
}

const previewBox: React.CSSProperties = {
  marginTop: '0.75rem',
  padding: '0.75rem 1rem',
  borderRadius: '10px',
  border: '1px solid #dbeafe',
  background: '#f8fbff',
  fontSize: '0.82rem',
  lineHeight: 1.45,
}

const previewTitle: React.CSSProperties = {
  margin: '0 0 0.5rem',
  fontSize: '0.85rem',
  fontWeight: 600,
  color: '#1e3a5f',
}

const previewGrid: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
  gap: '0.35rem 1rem',
}

export function TaxCertificatePreview({
  vars,
  clinicName,
  clinicInn,
}: {
  vars: TaxPreviewVars
  clinicName?: string
  clinicInn?: string
}) {
  const [last, first, mid] = splitName(vars.payer_full_name || '')
  const samePerson = !vars.services_patient_different
  const [p2Last, p2First, p2Mid] = samePerson
    ? ['', '', '']
    : splitName(vars.services_patient_full_name || '')

  return (
    <div style={previewBox}>
      <p style={previewTitle}>Предпросмотр формы КНД 1151156 (стр. 1–2)</p>
      <div style={previewGrid}>
        <span>
          <strong>Клиника:</strong> {clinicName || '—'}
        </span>
        <span>
          <strong>ИНН:</strong> {clinicInn || '—'}
        </span>
        <span>
          <strong>Номер:</strong> {vars.certificate_number || '—'}
        </span>
        <span>
          <strong>Год:</strong> {vars.period_end?.slice(0, 4) || '—'}
        </span>
        <span>
          <strong>Налогоплательщик:</strong> {[last, first, mid].filter(Boolean).join(' ') || '—'}
        </span>
        <span>
          <strong>ИНН плательщика:</strong> {vars.payer_inn || '—'}
        </span>
        <span>
          <strong>Код 1:</strong> {formatAmount(vars.code1_rub)}
        </span>
        <span>
          <strong>Код 2:</strong> {formatAmount(vars.code2_rub)}
        </span>
        <span>
          <strong>Налогоплательщик = пациент:</strong> {samePerson ? 'да' : 'нет'}
        </span>
      </div>
      {!samePerson && (
        <div style={{ marginTop: '0.5rem' }}>
          <strong>Стр. 2 — кому оказаны услуги:</strong>{' '}
          {[p2Last, p2First, p2Mid].filter(Boolean).join(' ') || '—'}
          {vars.services_patient_inn ? ` · ИНН ${vars.services_patient_inn}` : ''}
        </div>
      )}
      {vars.finance_source_mis_id && vars.finance_source_label && (
        <div style={{ marginTop: '0.35rem', color: '#475569' }}>
          <strong>Источник финансов:</strong> {vars.finance_source_label}
        </div>
      )}
    </div>
  )
}
